import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: false,
    customerDetails: '',
    error: '',
    salesSelfBillDetails: '',
    storeSalesDetails: '',
    customerPaymentDetails: '',
};

export default function salesManagementReducer(state = initState, action) {
    switch (action.type) {
        case actions.CUSTOMER_DETAILS_START: {
            return {
                ...state,
                loader: true,
                customerDetails: '',
            };
        }
        case actions.CUSTOMER_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                customerDetails: action.payload,
            };
        }
        case actions.CUSTOMER_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.SALES_SELFBILL_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.SALES_SELFBILL_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                salesSelfBillDetails: action.payload,
            };
        }
        case actions.SALES_SELFBILL_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CUSTOMER_PAYMNET_DETAILS_START: {
            return {
                ...state,
                loader: true,
                error: ''
            };
        }
        case actions.CUSTOMER_PAYMNET_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                customerPaymentDetails: action.payload,
            };
        }
        case actions.CUSTOMER_PAYMNET_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.STORE_SALES_DETAILS_START: {
            return {
                ...state,
                loader: true,
                error: ''
            };
        }
        case actions.STORE_SALES_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                storeSalesDetails: action.payload,
            };
        }
        case actions.STORE_SALES_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CLEAR_MANAGEMENT_DETAILS_START: {
            return initState;
        }
        case actions.CLEAR_MANAGEMENT_DETAILS_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}